<template>
  <transition name="login">

    <div class="login-wrapper">

      <div class="top-progress-bar" :style="{ width: progressWidthSize }"></div>
      <img :src="logoImage" class="logo-image" v-if="!isDone"/>

      <div class="login" :class="{ 'start-fade': isDone }">

        <image-background :duration="500" :delay="3000" :images="bgArr"/>
        <login-panel v-if="isDone" :login="login"/>

      </div>

    </div>

  </transition>
</template>

<script>
import { parseJwt } from '@/utils/utils';

import Logo from '@/assets/images/logo.svg';
import Bg1 from '@/assets/images/background-1.jpg';
import Bg2 from '@/assets/images/background-2.jpg';
import Bg3 from '@/assets/images/background-3.jpg';
import Bg4 from '@/assets/images/background-4.jpg';

import ImageBackground from '@/spa/components/login/layouts/ImageBackground';
import LoginPanel from '@/spa/components/login/layouts/LoginPanel';

export default {
  name: 'LoginComponent',
  components: {
    ImageBackground,
    LoginPanel,
  },
  methods: {
    async login({ email, password }) {
      const user = { email, password };

      const result = await this.$store.dispatch('login', user);

      if (result.response) this.$sidebar.replaceMove('dashboard');
      this.$toast(result.message);
    },

    imageLoading(images) {
      images.forEach((image, index) => {
        this.tempImages.push(new Image());

        this.tempImages[index].onload = () => {
          setTimeout(() => {
            this.progress += 1;
          }, 10 * index);
        };

        this.tempImages[index].src = image;
      });
    },

    updateValue(payload) {
      this[payload.target] = payload.value;
    },

    initTokenCheck() {
      const tokenName = 'winepointUserToken';
      const token = document.cookie.match(`(^|;) ?${tokenName}=([^;]*)(;|$)`);

      if (!token) {
        this.$store.commit('setFoldState', true);
        return;
      }

      const decryptToken = parseJwt(token[2]);
      this.$store.commit('initUser', decryptToken);

      if (window.innerWidth <= 1024) this.$store.commit('setFoldState', true);
      else this.$store.commit('setFoldState', false);

      this.$sidebar.replaceMove('dashboard');
    },
  },

  computed: {
    isDone() {
      return this.progress === this.bgArr.length;
    },

    progressWidthSize() {
      return this.isDone ? 0 : `${(100 / this.bgArr.length) * this.progress}vw`;
    },

    isLoading() {
      return this.$store.getters.isLoadingState;
    },
  },

  data() {
    return {
      userId: '',
      userPassword: '',
      idInputFocused: false,
      passwordInputFocused: false,
      bgArr: [Bg1, Bg2, Bg3, Bg4],
      tempImages: [],
      progress: 0,
      logoImage: Logo,
    };
  },

  async created() {
    this.imageLoading(this.bgArr);

    this.initTokenCheck();
  },
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  position: relative;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

  .top-progress-bar {
    position: absolute;
    top: 0;
    left: 0;

    height: 5px;

    background: #0fb8ad;

    z-index: 10;

    transition: width 0.5s ease-in-out;
  }

  .logo-image {
    position: absolute;

    width: 148px;
  }

  .login {
    position: relative;

    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    opacity: 0;
    transition: opacity 0.5s ease-in-out;

    .container-login-page {
      width: 100%;
      height: 100vh;
      transition: all 0.5s;
      background-position: left;
      background-size: cover;
      background-repeat: no-repeat;

      .wrapper-login-page {
        padding: 64px 32px;
        width: 360px;
        background-color: #ffffff;
        border-radius: 16px;
        text-align: left;
        z-index: 1;
        box-shadow: 1px 16px 32px rgba(0,0,0,0.3);

        .header {
          text-align: center;
          margin-bottom: 48px;
          img {
            height: 32px;
          }
          .title {
            margin-top: 8px;
          }
        }
        .action-area {

          .wrapper-button {
            display: flex;
            flex-direction: row-reverse;

            .btn-login {
              width: 84px;
              height: 36px;
              border-radius: 3px;
              background-color: #008ff8;
              border: none;
              color: #ffffff;

              &:disabled {
                background-color: #bbbbbb;
              }
            }
          }
        }
      }
    }
  }

  .start-fade {
    opacity: 1;
  }

  .loading {
    z-index: 100;
  }
}

.login-enter-active, .login-leave-active {
  transition: opacity 0.2s;
}

.login-enter, .login-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/login/LoginComponent.vue